module.exports = __webpack_public_path__ + "static/img/icon-target.b0e30b83.svg";